import {
  AUTH_SET_USER_ID,
  AUTH_SET_EMAIL,
  AUTH_SET_ACCESS_TOKEN,
  AUTH_SET_ACCESS_TOKEN_DATE,
  AUTH_SET_ACCESS_SESSION,
  AUTH_SET_REFRESH_TOKEN,
  AUTH_SET_REFRESH_TOKEN_DATE,
  AUTH_SET_CUSTOMER_ID,
  AUTH_SET_CUSTOMER_NAME,
  AUTH_SET_CUSTOMER_CONTACT_ID,
  AUTH_SET_CUSTOMER_CONTACT_NAME,
  AUTH_SET_STATUS,
  AUTH_SET_ERROR,
  AUTH_SET_AUTH_TYPE,
} from '@/store/mutation-types';

let mutation_types = {
  AUTH_SET_USER_ID,
  AUTH_SET_EMAIL,
  AUTH_SET_ACCESS_TOKEN,
  AUTH_SET_ACCESS_TOKEN_DATE,
  AUTH_SET_ACCESS_SESSION,
  AUTH_SET_REFRESH_TOKEN,
  AUTH_SET_REFRESH_TOKEN_DATE,
  AUTH_SET_CUSTOMER_ID,
  AUTH_SET_CUSTOMER_NAME,
  AUTH_SET_CUSTOMER_CONTACT_ID,
  AUTH_SET_CUSTOMER_CONTACT_NAME,
  AUTH_SET_STATUS,
  AUTH_SET_ERROR,
  AUTH_SET_AUTH_TYPE,
};

import {
  AUTH_REGISTER_REQUEST,
  AUTH_CREATE_GUEST,
  AUTH_RESEND_CONFIMATION,
  AUTH_VERIFY,
  AUTH_LOGOUT,
  AUTH_LOGIN,
  AUTH_PASSWORD_RESET_REQUEST,
  AUTH_PASSWORD_RESET_COMPLETE,
  AUTH_CHECK_LOGIN,
  AUTH_CUSTOMER_CONTACT,
} from '@/store/action-types';

let action_types = {
  AUTH_REGISTER_REQUEST,
  AUTH_CREATE_GUEST,
  AUTH_RESEND_CONFIMATION,
  AUTH_VERIFY,
  AUTH_LOGOUT,
  AUTH_LOGIN,
  AUTH_PASSWORD_RESET_REQUEST,
  AUTH_PASSWORD_RESET_COMPLETE,
  AUTH_CHECK_LOGIN,
  AUTH_CUSTOMER_CONTACT
};

import AuthRepository from "@/auth/AuthRepository";
import UserModel from "@/models/crm/UserModel";

const state = {
  user_id: getCookie('auth__user_id'),
  user_email: getCookie('auth__user_email'),
  access_token: getCookie('auth__access_token'),
  access_token_date: getCookie('auth__access_token_date'),
  access_session: getCookie('auth__access_session'),
  refresh_token: getCookie('auth__refresh_token'),
  refresh_token_date: getCookie('auth__refresh_token_date'),
  customer_id: getCookie('auth__customer_id'),
  customer_name: getCookie('auth__customer_name'),
  customer_contact_id: getCookie('auth__customer_contact_id'),
  customer_contact_name: getCookie('auth__customer_contact_name'),
  authType: getCookie('auth__auth_type') || 'standard',
  status: null,
  error: null,
}

// function getCookie(key) {
//   let val = window.$cookies.get(key);
//   if(val && val !== '') {
//     return val;
//   }
//   return null;
// }
function getCookie(key) {
  let val = localStorage[key];
  if (val && val !== '') {
    return val;
  }
  return null;
}

const getters = {
  getAuthUserID: state => state.user_id,
  getAuthEmail: state => state.user_email,
  getAuthAccessToken: state => state.access_token,
  getAuthAccessTokenDate: state => state.access_token_date,
  getAuthSession: state => state.access_session,
  getAuthRefreshToken: state => state.refresh_token,
  getAuthRefreshTokenDate: state => state.refresh_token_date,
  getAuthCustomerID: state => state.customer_id,
  getAuthCustomerName: state => state.customer_name,
  getAuthCustomerContactID: state => state.customer_contact_id,
  getAuthCustomerContactName: state => state.customer_contact_name,
  getAuthType: state => state.authType,
  getAuthenticationStatus: state => state.status,
  getAuthenticationError: state => state.error,
  isAuthenticated: state => !!state.access_token,
  hasError: state => !!state.error
};

function cleanMutationValue(val) {
  if (val && val !== '') {
    return val;
  }
  return null;
}

function setCookie(key, val) {
  if (val && val !== '') {
    localStorage[key] = val;
  } else {
    if (localStorage[key]) {
      delete localStorage[key];
    }
  }
}

const mutations = {
  AUTH_SET_USER_ID: function (state, user_id) {
    state.user_id = cleanMutationValue(user_id);
    setCookie('auth__user_id', state.user_id);
    //window.$cookies.set('auth__user_id', state.user_id);
  },
  AUTH_SET_EMAIL: function (state, email) {
    state.email = cleanMutationValue(email);
    setCookie('auth__email', state.email);
    //window.$cookies.set('auth__email', state.email);
  },
  AUTH_SET_ACCESS_TOKEN: function (state, access_token) {
    state.access_token = cleanMutationValue(access_token);
    setCookie('auth__access_token', state.access_token);
    //window.$cookies.set('auth__access_token', state.access_token);
  },
  AUTH_SET_ACCESS_TOKEN_DATE(state, date) {
    state.access_token_date = cleanMutationValue(date);
    setCookie('auth__access_token_date', state.access_token_date);
  },
  AUTH_SET_ACCESS_SESSION: function (state, access_session) {
    state.access_session = cleanMutationValue(access_session);
    setCookie('auth__access_session', state.access_session);
    //window.$cookies.set('auth__access_session', state.access_session);
  },
  AUTH_SET_REFRESH_TOKEN: function (state, refresh_token) {
    state.refresh_token = cleanMutationValue(refresh_token);
    setCookie('auth__refresh_token', state.refresh_token);
    //window.$cookies.set('auth__refresh_token', state.refresh_token);
  },
  AUTH_SET_REFRESH_TOKEN_DATE(state, date) {
    state.refresh_token_date = cleanMutationValue(date);
    setCookie('auth__refresh_token_date', state.refresh_token_date);
  },
  AUTH_SET_CUSTOMER_ID: function (state, customer_id) {
    state.customer_id = cleanMutationValue(customer_id);
    localStorage['auth__customer_id'] = state.customer_id;
    setCookie('auth__customer_id', state.customer_id);
    //window.$cookies.set('auth__customer_id', state.customer_id);
  },
  AUTH_SET_CUSTOMER_NAME: function (state, customer_name) {
    state.customer_name = cleanMutationValue(customer_name);
    setCookie('auth__customer_name', state.customer_name);
    //window.$cookies.set('auth__customer_name', state.customer_name);
  },
  AUTH_SET_CUSTOMER_CONTACT_ID: function (state, customer_contact_id) {
    state.customer_contact_id = cleanMutationValue(customer_contact_id);
    setCookie('auth__customer_contact_id', state.customer_contact_id);
    //window.$cookies.set('auth__customer_contact_id', state.customer_contact_id);
  },
  AUTH_SET_CUSTOMER_CONTACT_NAME: function (state, customer_contact_name) {
    state.customer_contact_name = cleanMutationValue(customer_contact_name);
    setCookie('auth__customer_contact_name', state.customer_contact_name);
    //window.$cookies.set('auth__customer_contact_name', state.customer_contact_name);
  },
  AUTH_SET_STATUS: function (state, status) {
    state.status = cleanMutationValue(status);
  },
  AUTH_SET_ERROR: function (state, error) {
    state.error = cleanMutationValue(error);
  },
  AUTH_SET_AUTH_TYPE: function (state, authType) {
    state.authType = cleanMutationValue(authType) || 'standard';
    setCookie('auth__auth_type', state.authType);
  },
}

const actions = {

  AUTH_REGISTER_REQUEST: ({ commit, dispatch }, registrationData) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'register__request');

      if (registrationData.contact && registrationData.contact.phone) {
        registrationData.contact.phone = '+' + registrationData.contact.phone.replace(/\D/g, '');
      }

      AuthRepository.signUp(registrationData).then((response) => {
        if (response && response.status && response.status === 200) {

          let data = response.data.data;
          commit(AUTH_SET_USER_ID, data.user.id);
          commit(AUTH_SET_EMAIL, data.user.email);
          if (data.confirmed) {
            commit(AUTH_SET_STATUS, 'register__success');
            dispatch(AUTH_LOGIN, { username: registrationData.email, password: registrationData.password, ignore_customer_check: true }).then(() => {
              resolve(data);
            });
          } else {
            resolve(data);
            commit(AUTH_SET_STATUS, 'register__confirmation');
          }
        } else {
          commit(AUTH_SET_STATUS, 'register__error');
          let err = 'User create failed';
          let msg = response.error || parseErrResponse(err);
          commit(AUTH_SET_ERROR, (msg !== null ? msg : 'User guest error'));
          reject(msg);
        }
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'register__error');
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Sign up error'));
        reject(err);
      });
    });
  },

  AUTH_CREATE_GUEST: ({ commit, dispatch }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'create_guest__request');
      AuthRepository.signUpGuest(username, username, password).then((response) => {
        if (response && response.status && response.status === 201) {
          let data = response.data;
          commit(AUTH_SET_USER_ID, data.id);
          commit(AUTH_SET_EMAIL, data.email);
          commit(AUTH_SET_STATUS, 'create_guest__success');
          dispatch(AUTH_LOGIN, { username, password, ignore_customer_check: true }).then(() => {
            resolve(data);
          });
        } else {
          commit(AUTH_SET_STATUS, 'create_guest__error');
          let err = 'Guest create failed';
          let msg = response.error || parseErrResponse(err);
          commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Create guest error'));
          reject(msg);
        }
      }, (err) => {
        commit(AUTH_SET_STATUS, 'create_guest__error');
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Create guest error'));
        reject(err);
      });
    });
  },

  AUTH_RESEND_CONFIMATION: ({ commit }, { username }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'confirmation__resend');
      AuthRepository.resendConfirmation(username).then((data) => {
        commit(AUTH_SET_STATUS, 'confirmation__resent');
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'confirmation__error');
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Re-send error'));
        reject(err);
      });
    });
  },

  AUTH_CONFIRMATION: ({ commit }, { username, code }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'confirmation__request');
      AuthRepository.confirmSignUp(username, code).then((response) => {
        if (response && response.status && response.status === 200) {
          commit(AUTH_SET_STATUS, 'confirmation__success');
          resolve();
        } else {
          commit(AUTH_SET_STATUS, 'confirmation__error');
          reject('Confirmation failed');
        }
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'confirmation__error');
        let msg = parseErrResponse(err);
        if (msg == 'User cannot be confirm. Current status is CONFIRMED') {
          commit(AUTH_SET_ERROR, 'User is already confirmed.');
        } else {
          commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Confirmation error'));
        }
        reject(err);
      });
    });
  },

  AUTH_LOGOUT: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'sign_out__request');

      const resetState = () => {
        commit(AUTH_SET_STATUS, 'sign_out__success')
        commit(AUTH_SET_USER_ID, null)
        commit(AUTH_SET_EMAIL, null)
        commit(AUTH_SET_ACCESS_TOKEN, null)
        commit(AUTH_SET_ACCESS_TOKEN_DATE, null)
        commit(AUTH_SET_REFRESH_TOKEN, null)
        commit(AUTH_SET_REFRESH_TOKEN_DATE, null)
        commit(AUTH_SET_CUSTOMER_ID, null)
        commit(AUTH_SET_CUSTOMER_NAME, null)
        commit(AUTH_SET_CUSTOMER_CONTACT_ID, null)
        commit(AUTH_SET_CUSTOMER_CONTACT_NAME, null)
        commit(AUTH_SET_STATUS, null)
        commit(AUTH_SET_AUTH_TYPE, 'standard')
      }

      // Check if the access token is still valid
      if (!state.access_token || !state.access_token_date || (parseInt(state.access_token_date) + (15 * 60 * 1000)) < Date.now()) {
        resetState()
        resolve()
      } else if (!state.refresh_token || !state.refresh_token_date || (parseInt(state.refresh_token_date) + (1 * 60 * 60 * 1000) + (15 * 60 * 1000)) < Date.now()) {
        resetState()
        resolve()
      } else {
        AuthRepository.logout().then((data) => {
          resetState()
          resolve(data);
        }).catch((err) => {


          resetState()
          resolve()
          // commit(AUTH_SET_STATUS, 'sign_out__error');
          // const msg = parseErrResponse(err);
          // commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Sign out error'));
          // reject(err);
        });
      }
    });
  },

  async AUTH_CUSTOMER_CONTACT({ commit }, { user_id }) {
    return await new Promise((resolve, reject) => {
      let user = new UserModel({ id: user_id });

      const params = {}
      params.connection = ['customer_contact.customer']

      user.fetch({ params }).then(() => {
        let contact = user.getCustomerContact();
        if (contact && contact.id) {
          let customer = contact.getCustomer();
          commit(AUTH_SET_CUSTOMER_ID, customer.id);
          commit(AUTH_SET_CUSTOMER_NAME, customer.full_name);
          commit(AUTH_SET_CUSTOMER_CONTACT_ID, contact.id);
          commit(AUTH_SET_CUSTOMER_CONTACT_NAME, contact.first_name);
        }
        resolve(contact)
      }).catch((err) => {
        reject(err || null);
      });
    });
  },

  AUTH_LOGIN: ({ commit, dispatch }, { username, password, ignore_customer_check }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'sign_in__request');
      AuthRepository.login(username, password).then((response) => {
        let response_data = response.data;
        let data = response_data.data;

        if (response_data.state === 'challenge') {
          commit(AUTH_SET_STATUS, 'sign_in__password_required');
          //let challenge = cleanMutationValue(data.challenge);
          commit(AUTH_SET_ACCESS_SESSION, data.session);
        } else {

          commit(AUTH_SET_STATUS, 'sign_in__success');
          commit(AUTH_SET_USER_ID, data.uuid);
          commit(AUTH_SET_EMAIL, username);
          commit(AUTH_SET_ACCESS_TOKEN, data.token);
          commit(AUTH_SET_ACCESS_TOKEN_DATE, Date.now());
          commit(AUTH_SET_REFRESH_TOKEN, data.refresh);
          commit(AUTH_SET_REFRESH_TOKEN_DATE, Date.now());
          commit(AUTH_SET_AUTH_TYPE, 'standard');
          if (ignore_customer_check) {
            resolve(data.uuid);
          } else {
            dispatch(AUTH_CUSTOMER_CONTACT, { user_id: data.uuid }).then(() => {
              resolve(data.uuid);
            }).catch((err) => {
              err = err || 'No customer contact found';
              dispatch(AUTH_LOGOUT);
              commit(AUTH_SET_STATUS, 'sign_in__error');

              if (err.response && err.response.data && err.response.data && err.response.data.data.message) {
                commit(AUTH_SET_ERROR, err.response.data.data.message)
              } else {
                commit(AUTH_SET_ERROR, 'Something went wrong please contact an administrator')
              }

              reject(err);
            });
          }
        }
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'sign_in__error');

        let error

        if (err.response && err.response.data && err.response.data) {
          error = err.response.data.data && err.response.data.data.message || err.response.data.message
        }

        let msg = parseErrResponse(err);

        if (error) {

          if (error === 'Invalid password') {
            commit(AUTH_SET_ERROR, 'Invalid password. Please try again or reset it if forgotten.')
          } else {
            commit(AUTH_SET_ERROR, error);
          }

        } else if (msg) {
          commit(AUTH_SET_ERROR, msg);
        } else {
          commit(AUTH_SET_ERROR, 'Sign in error');
        }

        reject(err);
      });
    });
  },

  async AUTH_CHECK_LOGIN ({ state, commit, dispatch }) {
    let now = Date.now()

    if (state.access_token && state.access_token_date && (parseInt(state.access_token_date) + (15 * 60 * 1000)) >= now) {
      return
    } else if (state.refresh_token && state.refresh_token_date && (parseInt(state.refresh_token_date) + (15 * 60 * 1000)) >= now) {
      return
    } else {
      try {
        if (!state.access_token || !state.refresh_token) {
          throw new Error('No access token or refresh token')
        }

        const response = await AuthRepository.refresh(state.refresh_token)
        const { data } = response.data

        now = Date.now()

        commit(AUTH_SET_STATUS, 'refresh__success')
        commit(AUTH_SET_ACCESS_TOKEN, data.token)
        commit(AUTH_SET_ACCESS_TOKEN_DATE, now)
        commit(AUTH_SET_REFRESH_TOKEN, data.refresh)
        commit(AUTH_SET_REFRESH_TOKEN_DATE, now)

        if (!state.customer_contact_id) {
          dispatch(AUTH_CUSTOMER_CONTACT, { user_id: state.user_id })
        }

        return data
      } catch (error) {
        dispatch(AUTH_LOGOUT)
        throw error
      }
    }
  },

  async AUTH_INVITE({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'invite__request');
      AuthRepository.invite(email, email, 'Password1!').then((response) => {
        //commit(AUTH_SET_USER_ID, data.uuid);
        //commit(AUTH_SET_EMAIL, email);
        commit(AUTH_SET_STATUS, 'invite__success');
        //console.log(response);
        resolve(response.data.id);
      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'invite__error');
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Invite error'));
        reject(err);
      });
    });
  },

  async AUTH_PASSWORD_RESET_REQUEST({ commit }, { username }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "password_reset_request__request");
      AuthRepository.passwordReset(username)
        .then(data => {
          commit(AUTH_SET_EMAIL, username);
          commit(AUTH_SET_STATUS, "password_reset_request__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "password_reset_request__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Password reset request error");
          reject(err);
        });
    });
  },

  AUTH_TOKEN_LOGIN: ({ commit, dispatch }, { initialToken }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, 'token_sign_in__request');
      commit(AUTH_SET_AUTH_TYPE, 'token');

      AuthRepository.loginWithResultsToken(initialToken).then((response) => {
        let response_data = response.data;
        let data = response_data.data;

        commit(AUTH_SET_STATUS, 'token_sign_in__success');
        commit(AUTH_SET_USER_ID, data.uuid);
        commit(AUTH_SET_ACCESS_TOKEN, data.token);
        commit(AUTH_SET_ACCESS_TOKEN_DATE, Date.now());
        commit(AUTH_SET_REFRESH_TOKEN, data.refresh);
        commit(AUTH_SET_REFRESH_TOKEN_DATE, Date.now());

        // We are explicitly NOT calling AUTH_CUSTOMER_CONTACT for token login
        resolve(data.uuid);

      }).catch((err) => {
        commit(AUTH_SET_STATUS, 'token_sign_in__error');
        commit(AUTH_SET_AUTH_TYPE, 'standard'); // Revert auth type on error
        let msg = parseErrResponse(err);
        commit(AUTH_SET_ERROR, (msg !== null ? msg : 'Token sign in error'));
        reject(err);
      });
    });
  },

  async AUTH_PASSWORD_RESET_COMPLETE({ commit }, { username, code, password }) {
    return new Promise((resolve, reject) => {
      commit(AUTH_SET_STATUS, "password_reset_confirm__request");
      AuthRepository.passwordResetConfirm(username, code, password)
        .then(data => {
          commit(AUTH_SET_EMAIL, username);
          commit(AUTH_SET_STATUS, "password_reset_confirm__success");
          resolve(data);
        })
        .catch(err => {
          commit(AUTH_SET_STATUS, "password_reset_confirm__error");
          let msg = parseErrResponse(err);
          commit(AUTH_SET_ERROR, msg !== null ? msg : "Password reset confirm error");
          reject(err);
        });
    });
  },

};

function parseErrResponse(err) {
  if (typeof err === 'string') {
    return err;
  } else if (typeof err === 'object') {
    return err.message;
  }
  return null;
}

export default {
  getters,
  mutations,
  actions,
  state
}
